import DashboardWidget from "../DashboardWidget";
import SickOutlinedIcon from '@mui/icons-material/SickOutlined';
import { useEffect, useState } from "react";
import dashboardServicev2 from "../../service/DashboardServicev2";
import subDays from "date-fns/subDays";
import format from "date-fns/format";
import WidgetDaySelection from "./WidgetDaySelection";
import { useHistory } from "react-router-dom";

const EViziteWidget = () => {

    const [loading, setLoading] = useState(false);
    const [sayi, setSayi] = useState(0);
    const toDate = new Date();

    const [day, setDay] = useState("30");

    const history = useHistory();

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const start = subDays(toDate, parseInt(day));
                const startDate = format(start, 'yyyy-MM-dd');
                const endDate = format(toDate, 'yyyy-MM-dd');
                const _sayi = await dashboardServicev2.getEViziteOnayBekleyenler({ startDate, endDate });
                setSayi(_sayi);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }

        })();
    }, [day]);

    const onClick = () => {
        history.push(`/eVizite?onayli=false&day=${day}`)
    };

    return (
        <DashboardWidget loading={loading} height={140 * 2.23}>
            <div style={{ textAlign: "center", color: "#7959FB", paddingTop: 24, width: "100%", position: "relative" }}>
                <WidgetDaySelection day={day} setDay={setDay} />
                <div style={{ cursor: "pointer" }} onClick={onClick}>
                    <SickOutlinedIcon sx={{ fontSize: 46, color: "#C4B6FF" }} />
                    <div style={{ fontSize: 28, lineHeight: "24px", marginBottom: 24 }}>E-Vizite</div>
                    <div style={{ fontSize: 60, fontWeight: 300, lineHeight: "72px" }}>
                        {new Intl.NumberFormat('tr-TR').format(sayi)}
                    </div>
                    <div style={{ fontSize: 16, paddingTop: 24, lineHeight: "24px", color: "rgba(0, 0, 0, 0.6)" }}>
                        Onay Bekleyen Rapor
                    </div>
                </div>
            </div>
        </DashboardWidget>
    )

}

export default EViziteWidget;
